import hyRequest from '@/service';
import { ISaleData } from './type';

enum DashboardApi {
  getSaleData = '/sale/query'
}

// 获取销售记录
export function getSaleData(data: {
  startTime: string;
  endTime: string;
  pageNumber: number;
  pageSize: number;
  condition?: string;
  type?: number;
}) {
  return hyRequest.post<ISaleData>({
    url: DashboardApi.getSaleData,
    data
  });
}
